import { Link } from "react-router-dom";
import { MapPin, Phone, Instagram } from "lucide-react";
import { waLink, WA_MESSAGES, trackWhatsApp } from "@/lib/whatsapp";
import Reveal from "./Reveal";
import WhatsAppIcon from "./WhatsAppIcon";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10">
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 70% 60% at 50% 110%, rgba(245,158,11,0.12), transparent 70%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
        <Reveal>
          <h2 className="font-display text-[13vw] font-extrabold leading-[0.95] tracking-tight sm:text-[9vw] lg:text-[7.5rem]">
            <span className="text-stroke block">Vamos explorar</span>
            <span className="block text-amber-400">o Rio?</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15} className="mt-12 flex flex-wrap items-center gap-8">
          <a
            href={waLink(WA_MESSAGES.default)}
            onClick={() => trackWhatsApp("rodape")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta-whatsapp"
            className="flex items-center gap-3 rounded-full bg-[#25D366] px-8 py-4 text-base font-semibold text-white shadow-[0_0_40px_rgba(37,211,102,0.3)] transition-[background-color,transform] duration-300 hover:scale-[1.03] hover:bg-[#20BD5A]"
          >
            <WhatsAppIcon className="h-5 w-5" />
            Chamar o Darlei no WhatsApp
          </a>
          <div className="flex flex-col gap-2 text-sm text-stone-400">
            <span className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-amber-400" />
              +55 21 98861-9303
            </span>
            <a
              href="https://instagram.com/darleiguiarj"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="flex items-center gap-2 transition-colors duration-300 hover:text-amber-400"
            >
              <Instagram className="h-4 w-4 text-amber-400" />
              @darleiguiarj
            </a>
            <span className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-amber-400" />
              Rio de Janeiro, RJ — Brasil
            </span>
          </div>
        </Reveal>

        <div className="mt-20 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">
            © {new Date().getFullYear()} Darlei Guia RJ — Guia de Turismo no Rio de Janeiro
          </p>
          <nav aria-label="Legal" className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link
              to="/privacidade"
              data-testid="footer-privacy-link"
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-400 transition-colors duration-300 hover:text-amber-400"
            >
              Política de Privacidade
            </Link>
            <Link
              to="/termos"
              data-testid="footer-terms-link"
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-400 transition-colors duration-300 hover:text-amber-400"
            >
              Termos de Uso
            </Link>
          </nav>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">
            Cadastur 19.967376.16-7 · darleiguiarj.com.br
          </p>
        </div>
      </div>
    </footer>
  );
}
